import styled from "styled-components";

export const Styles = styled.div`
  .about-page {
    .service-area {
      padding-bottom: 72px;

      @media (max-width: 767px) {
        padding: 0 0 10px;
      }
    }
  }
`;
